import React from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { IconButton } from "@mui/material";
import { notifyError } from "../utils/Toastify";

const SideMenu = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const handleComingSoon = () => {
    notifyError("Coming Soon!");
  };

  const menuItems = [
    {
      label: "MicroAgent CRM",
      path: `https://crm.microagent.services/autologin/?token=${token}&source_app=CHATBOT&target_app=CRM`,
    },
    {
      label: "MicroAgent Chatbot",
      path: `https://chatbot.microagent.services/autologin/?token=${token}`,
      current: true,
    },
    { label: "Voice Facilitator", path: "/dashboard/contacts" },
    { label: "MicroAgent LMS", path: "/dashboard/leads" },
    { label: "Performance Tracker", path: "/dashboard/cases" },
    { label: "MicroAgent Quiz App", path: "/dashboard/campaigns" },
    { label: "WhatsApp Integration", path: "/dashboard/products" },
    { label: "Telegram Integration", path: "/dashboard/orders" },
    { label: "Instagram Integration", path: "/dashboard/sales" },
  ];

  // Remove current:true items (e.g., CRM)
  const filteredMenuItems = menuItems.filter((item) => !item.current);

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
        <h2 className="text-lg font-bold">MicroAgents</h2>
        <IconButton
          className="!text-[#64748b] hover:text-gray-300"
          size="large"
        >
          <Menu />
        </IconButton>
      </div>

      <List>
        {filteredMenuItems.map((item, index) => (
          <ListItemButton
            key={item.label}
            onClick={() => {
              // ✅ Allow first two items to open links
              if (index === 0 || index === 1) {
                //   window.open(item.path, "_blank");
                window.location.href = item.path;
              } else {
                handleComingSoon();
              }
            }}
            sx={{
              color: "#64748b",
              "&:hover": { backgroundColor: "#1e293b", color: "#fff" },
              cursor: "pointer",
            }}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                fontSize: "15px",
                fontWeight: 500,
                marginBottom: "0.3rem",
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </div>
  );
};

export default SideMenu;
